import React from "react";
import { RTCICall } from "../modules/RTCICall";
import "../../assets/css/NBA.css";
import { isNullOrUndefined } from "./CommonFunctions";

class NBA extends React.Component {
  constructor(props) {
    super(props);
    this.pegaID = ((this.props.pageName.indexOf('home') > -1) && !isNullOrUndefined(window.homePageDynamicData) && !isNullOrUndefined(window.homePageDynamicData.Attribute) && !isNullOrUndefined(window.homePageDynamicData.Attribute.content)) ? window.homePageDynamicData.Attribute.content :
                  ((this.props.pageName.indexOf('contact') > -1) && !isNullOrUndefined(window.contactUsDynamicData) && !isNullOrUndefined(window.contactUsDynamicData.Attribute) && !isNullOrUndefined(window.contactUsDynamicData.Attribute.content)) ? window.contactUsDynamicData.Attribute.content : "";
  }
  getOS = () => {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
    }

    return os;
  };

  openLink = (item, e) => {
    if (
      item.insights.ctaurl !== null &&
      item.insights.ctaurl !== undefined &&
      item.insights.ctaurl !== ""
    ) {
      window.open(item.insights.ctaurl);
      let opSys = this.getOS();
      console.log("operating system", opSys);

      //TP changes for 5 intent propositions VCGBO-710
      let appChannelValue  = "";
      let intentlowercase = "";
      let strOutage = "";
      let strOutagetype = "";
      let strPPSHOutage ="PPSH_GENERIC_OUTAGE";
      intentlowercase = e.target.parentElement.parentElement.getAttribute("intent").toLowerCase();
      var intentArray = ["ppsh_generic_biml_lowermybill", "ppsh_generic_piml_manageautopay", "ppsh_generic_biml_pmt_arrng",
                          "ppsh_generic_autopay_cnf","ppsh_generic_outage_ipr"];
      if(intentArray.indexOf(intentlowercase)!== -1)  {
          //value exists
          appChannelValue = "ESUPPORT";
      }  
      else{
          appChannelValue = "NBA-ESUPPORT";
      }     

      if(intentlowercase != null){
        if(intentlowercase == strPPSHOutage.toLocaleLowerCase()){
            strOutage ="OutageType";
            strOutagetype = e.target.parentElement.parentElement.getAttribute("outagetype");
            console.log("PPSH_GEN_OUTAGE CLICK: "+strOutage + ':'+strOutagetype);
        }
    }
      
      let args = {
        intentCategory: "NBA_CLICK",
        activityCategory: "NBA_CLICK",
        intent: e.target.parentElement.parentElement.getAttribute("intent"),
        app_n_channel: appChannelValue,
        os: opSys,
        outage:strOutage,
        outagetype:strOutagetype,
        pegaSessionID: this.pegaID,
        userid: window.userinfo.userId,
        visionID : window.userinfo.visionId,
        accountID: window.userinfo.visionAcctId
      };
      RTCICall(args);
    }
    return false;
  };

  closeNBA = e => {
    let opSys = this.getOS();
    console.log("operating system", opSys);
    let intentlowercase = "";
    let strOutage = "";
    let strOutagetype = "";
    let strPPSHOutage ="PPSH_GENERIC_OUTAGE";
    intentlowercase = e.target.parentElement.getAttribute("intent").toLowerCase();
    if(intentlowercase != null){
      if(intentlowercase == strPPSHOutage.toLocaleLowerCase()){
          strOutage ="OutageType";
          strOutagetype = e.target.parentElement.getAttribute("outagetype");
          console.log("PPSH_GEN_OUTAGE READ: "+strOutage + ':'+strOutagetype);
      }
  }
    
    let args = {
      intentCategory: "NBA_READ",
      activityCategory: "NBA_READ",
      intent: e.target.parentElement.getAttribute("intent"),
      app_n_channel: "NBA-ESUPPORT",
      os: opSys,
      outage:strOutage,
      outagetype:strOutagetype,
      pegaSessionID: this.pegaID,
      userid: window.userinfo.userId,
      visionID : window.userinfo.visionId,
      accountID: window.userinfo.visionAcctId
    };
    e.target.parentElement.parentElement.remove();
    RTCICall(args);
    let nextNBAItem = document.querySelector('.w_info-band.hide');
    if(!isNullOrUndefined(nextNBAItem)) {
      nextNBAItem.classList.remove('hide');
      args = {
        intentCategory: "NBA_DISPLAY",
        activityCategory: "NBA_DISPLAY",
        intent: nextNBAItem.querySelector('.w_info-band-content').getAttribute("intent"),
        app_n_channel: "NBA-ESUPPORT",
        os: opSys,
        pegaSessionID: this.pegaID,
        userid: window.userinfo.userId,
        visionID : window.userinfo.visionId,
        accountID: window.userinfo.visionAcctId
      }
      RTCICall(args);
    }
  };

  render() {
    let NBAIndex = 0;
    let Outagetype ="";
    let strPPSHOutage ="PPSH_GENERIC_OUTAGE";
    if (
      this.props.NBAData !== null &&
      this.props.NBAData !== undefined &&
      this.props.NBAData.length > 0 &&
      window.oneAppFlag !== true 
    ) {
      return (
        <section className="w_top-nbo-text m_nba" key="NBA">
          {this.props.NBAData.map((item, index) => {
            if(item.resourceid.toLowerCase() == strPPSHOutage.toLocaleLowerCase() ){
              Outagetype = item.insights.outagetype;
            }
            if(!isNullOrUndefined(item.insights.verbiage) && item.insights.verbiage !== "" ) {
              NBAIndex = NBAIndex + 1;
            return (
              <React.Fragment key={index}>
                <div className={(NBAIndex > 2) ? "w_info-band animated warning hide" : "w_info-band animated warning"}>
                  <div className="w_info-band-content" intent={item.resourceid} outagetype={Outagetype}>
                    <p>
                      {item.insights.verbiage}
                      <a 
                        className={
                          !isNullOrUndefined(item.insights.ctaurl) &&
                          item.insights.ctaurl !== ""
                            ? "m_button-next white"
                            : "m_button-next hide"
                        }
                        onClick={e => this.openLink(item, e)}
                        data-track={item.insights.ctatext}
                      >
                        {item.insights.ctatext}
                      </a>
                    </p>
                    <a
                      className="info-band-close"
                      onClick={e => this.closeNBA(e)}
                    >
                      x
                    </a>
                  </div>
                </div>
              </React.Fragment>
            );
            } else return null
          })}
        </section>
      );
    } else {
      return null;
    }
  }
}

export default NBA;



// WEBPACK FOOTER //
// ./src/components/modules/NBA.js